import React from 'react';
import { t } from 'i18next';
import {
  Container, Logo, TextBox, TextContainer, Box, Arrow, Navigate,
} from './css';
import { H1, H3 } from '../../theme/typography';

const NotFoundContent = () => (
  <Container>
    <Box>
      <Logo />
      <TextContainer>
        <TextBox>
          <H1>{t('NotFoundTitle')}</H1>
          <H3>{t('ErrorText')}</H3>
        </TextBox>
        <Navigate to="/">
          <Box><H3>{t('GoHome')}</H3></Box>
          <Arrow />
        </Navigate>
      </TextContainer>

    </Box>
  </Container>
);

export default NotFoundContent;
